import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {WorkflowStatusFilterComponent} from 'src/app/archive/workflow-status-filter/workflow-status-filter.component';
import {BaseGeneralComponent} from 'src/app/BaseGeneralComponent';
import {DialogSendEmailComponent} from 'src/app/general-components/dialog-send-email/dialog-send-email.component';
import {DialogYearMonthComponent} from 'src/app/general-components/dialog-year-month/dialog-year-month.component';
import {ActualQuantityFilterComponent} from 'src/app/general-components/filter/actual-quantity-filter/actual-quantity-filter.component';
import {ContractTypeFilterComponent} from 'src/app/general-components/filter/contract-type-filter/contract-type-filter.component';
import {LocalCustomerFilterComponent} from 'src/app/general-components/filter/local-customer-filter/local-customer-filter.component';
import {NumAnnoMeseFilterComponent} from 'src/app/general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {ReferenceMonthFilterComponent} from 'src/app/general-components/filter/reference-month-filter/reference-month-filter.component';
import {RegionFilterComponent} from 'src/app/general-components/filter/region-filter/region-filter.component';
import {ResourceUnitFilterComponent} from 'src/app/general-components/filter/resource-unit-filter/resource-unit-filter.component';
import {Sl1FilterComponent} from 'src/app/general-components/filter/sl1-filter/sl1-filter.component';
import {ContractTypeService} from 'src/app/general-services/service-contract-type/contract-type.service';
import {LoaderService} from 'src/app/general-services/service-loader/loader.service';
import {LocalCustomerAnagrafService} from 'src/app/general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {NumAnnoMeseService} from 'src/app/general-services/service-num-anno-mese/num-anno-mese.service';
import {RegionService} from 'src/app/general-services/service-region-anagraf/region-service.service';
import {ResourceUnitService} from 'src/app/general-services/service-resources-units-anagraf/resource-unit.service';
import {Sl1AnagrafService} from 'src/app/general-services/service-sl1-services/sl1-anagraf.service';
import {ConsuntivoVolumiService} from 'src/app/monthly-actual/consuntivo-volumi/service-consuntivo-volumi/consuntivo-volumi.service';
import {AllSettingsFilterModel} from 'src/models/AllSettingsFilterModel';
import {GenericArray} from 'src/models/GenericArray';
import {Offset} from 'src/models/Offset';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {BillingConsuntivoService} from '../service-billing-consuntivo/billing-consuntivo.service';
import { ClaimsFilterComponent } from 'src/app/general-components/filter/claims-filter/claims-filter.component';


@Component({
  selector: 'app-filter-billing-consuntivo',
  templateUrl: './filter-billing-consuntivo.component.html',
  styleUrls: ['./filter-billing-consuntivo.component.scss']
})
export class FilterBillingConsuntivoComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() numAnnoMeseData?: any;
  @Input() filter?: any; // TODO usare un modello per i billing
  @Input() reportSection?: boolean;
  @Input() isRecovery?: boolean;
  @Input() isComparing?: boolean;
  @Input() isError?: boolean;
  @Input() isArchive?: boolean;

  contractTypeData?: any;
  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;
  designServiceData: any;
  orderCode: string;
  chargingStructure: string;
  remunerationType: string; // todo sostituire con contract type
  serviceType: string;
  invoiceCode: string;
  invoiceDescription: string;
  country: string;
  tower: string;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;
  @ViewChild(ReferenceMonthFilterComponent, { static: true }) referenceMonthFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(ResourceUnitFilterComponent, { static: true }) resourceUnitFilterComponent;
  @ViewChild(ContractTypeFilterComponent, { static: true }) contractTypeFilterComponent;
  @ViewChild(Sl1FilterComponent, { static: true }) designServicesFilterComponent;
  @ViewChild(ClaimsFilterComponent, { static: true }) claimsFilterComponent;
  @ViewChild(ActualQuantityFilterComponent, { static: true }) actualQuantityFilterComponent;
  @ViewChild(WorkflowStatusFilterComponent) workFlowStatusFilterComponent;

  filterSingle: AllSettingsFilterModel;
  shareNameFormControl = new FormControl();
  applicationDescriptionFormControl = new FormControl();
  labelAnnoMeseRif: string;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  intermittentBool: boolean;
  // actualQuantityFilter: number;
  contractType: any;
  localCustomer: any;
  constructor(private loaderService: LoaderService,
              private consuntivoVolumiService: ConsuntivoVolumiService,
              private billingService: BillingConsuntivoService,
              private numAnnoMeseService: NumAnnoMeseService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private resourceUnitService: ResourceUnitService,
              private sl1AnagrafService: Sl1AnagrafService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
    }

  ngOnInit(): void {
    // if (!this.filter) {
    //   this.filter = new ConsuntivoVolumiModel();
    // }
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    this.labelAnnoMeseRif = 'Reference Month';
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.BILLING_CONSUMPTIVE_FILTER))) {
      const filterStorage: any = JSON.parse(
        sessionStorage.getItem(this.SESSION_STORAGE_LABELS.BILLING_CONSUMPTIVE_FILTER)
      );
      this.filter = filterStorage;
      this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
      this.filter.claims = filterStorage.claim as boolean;
      // this.actualQuantityFilter = filterStorage.actualQuantityFilter;
      this.orderCode = filterStorage.orderCode;
      this.chargingStructure = filterStorage.chargingStructure;
      this.remunerationType = filterStorage.contractType;
      this.serviceType = filterStorage.serviceType;
      this.invoiceCode = filterStorage.invoiceCode;
      this.invoiceDescription = filterStorage.invoiceDescription;
      this.country = filterStorage.country;
      this.shareNameFormControl.setValue(this.filter.shareName);
      this.applicationDescriptionFormControl.setValue(this.filter.applicationDescription);
    }
    // else {
    //   this.actualQuantityFilter = 1;
    //   this.filter.actualQuantityFilter = 1;
    // }
    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllResourceUnitObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      allSettingsFilterModel).pipe();
    if (isReset) {
      this.orderCode = null;
      this.chargingStructure = null;
      this.remunerationType = null;
      this.serviceType = null;
      this.invoiceCode = null;
      this.invoiceDescription = null;
      this.localCustomerData = null;
      this.tower = null;
      this.country = null;
    }
    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable,
              getAllResourceUnitObservable, getAllDesignServicesObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];
          this.designServiceData = resultFork[4];

          if (!isReset) {
            this.loaderService.display(false);
          }
          // else {
          //   this.dataFiltered.emit({filter: this.getFilterItem(), actualQuantityFilter: this.actualQuantityFilter});
          // }

        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    if(!this.filter.provider.cod.includes("KYN"))
      this.filter.region = event;
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;
    this.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
    this.contractType = event;

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    /** const getAllNumAnnoMeseFilteredObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filterSingle.contractType).pipe(); **/
    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    // observableList.push(getAllNumAnnoMeseFilteredObservable);
    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          // this.numAnnoMeseData = resultFork[0];
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.resourceUnitData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;
          this.filter.designServices = this.filterSingle.sl1;

          /** if (!BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
            const numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;
            this.filter.numAnnoMese = numAnnoMese;
          } **/

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptResourceUnitChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.resourceUnit = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllDesignServicesObservable: Observable<any> = this.sl1AnagrafService.getListInAllSettings(
      this.sl1AnagrafService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllDesignServicesObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.designServiceData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.designServices = this.filterSingle.sl1;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptDesignServicesChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.sl1 = event;
    this.tower = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllResourceUnitFilteredObservable: Observable<any> = this.resourceUnitService.getListInAllSettings(
      this.resourceUnitService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllResourceUnitFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.resourceUnitData = resultFork[3];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.resourceUnit = this.filterSingle.resourceUnit;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptActualQuantityFilterChange($event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptIsClaimsChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptOrderCodeChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptCountryChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptChargingStructureChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRemunerationTypeChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptServiceTypeChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptInvoiceCodeChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptInvoiceDescriptionChange(value: string) {
    if (!this.reportSection) {
      this.intermittentBool = value !== '';
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      const filterStorage: any = this.filter as any;
      // filterStorage.actualQuantityFilter = this.actualQuantityFilter;
      filterStorage.orderCode = this.orderCode;
      filterStorage.chargingStructure = this.chargingStructure;
      filterStorage.remunerationType = this.remunerationType;
      filterStorage.serviceType = this.serviceType;
      filterStorage.invoiceCode = this.invoiceCode;
      filterStorage.invoiceDescription = this.invoiceDescription;
      filterStorage.country = this.country;
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.BILLING_CONSUMPTIVE_FILTER, JSON.stringify(filterStorage));

    }
    this.dataFiltered.emit({filter: this.getFilterItem(), isComparing: this.isComparing});
  }

  private getFilterItem() {
    const filterItem = this.filter;
    if (!this.isArchive) {
      filterItem.workflowStatus = undefined;
    }
    return filterItem;
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter;  // TODO ???
    this.filter.provider =  JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.isRecovery = this.isRecovery;

    this.filter.numAnnoMeseRif = null;
    this.filter.contractType = null;
   
    this.filter.resourceUnit = null;
    this.filter.workflowStatus = null;
    this.filter.claim = null;
    this.filter.claims = null;

    // this.numAnnoFilterComponent.reset();
    this.referenceMonthFilterComponent.reset();
    this.claimsFilterComponent.reset();
    if (this.filter.provider.cod !== this.PROVIDER_IBM || !this.filter.provider.cod.includes(this.PROVIDER_KYN)) {
      this.contractTypeFilterComponent = null;
      this.contractType = null;
    }
    if (this.filter.provider.cod !== this.PROVIDER_DXC) {
      this.localCustomerFilterComponent = null;
      this.localCustomer = null;
    }

    if(!this.filter.provider.cod.includes('KYN')){
      this.filter.region = null;
      this.filter.country = null;
      this.country = null;
      this.designServicesFilterComponent = null;
      this.filter.designServices = null;
      this.tower = null;
    }
    

    this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

    this.applicationDescriptionFormControl.setValue(this.filter.applicationDescription);
    this.shareNameFormControl.setValue(this.filter.shareName);

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        this.numAnnoMeseData = resultYearMonth;

        const providerDefault = this.filter.provider;
        this.numAnnoMeseData =  this.filterFromDxc(providerDefault, resultYearMonth);

        this.filter.numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;

        // this.actualQuantityFilter = null;
        this.filter.orderCode = null;
        this.filter.chargingStructure = null;
        this.filter.serviceType = null;
        this.filter.invoiceCode = null;
        this.filter.invoiceDescription = null;
        this.filter.localCustomer = null;
        this.filter.designServices = null;
        this.filter.country = null;
        const filterStorage: any = this.filter as any;
        // filterStorage.actualQuantityFilter = this.actualQuantityFilter;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.BILLING_CONSUMPTIVE_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromConsuntivoVolumiModel(this.filter);

        this.initFilter(this.filterSingle, isReset);

        this.loaderService.display(false);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
     });
  }

  downloadXlsx(isGrouped: boolean) {
    this.getAllFilters();
    const reportFilter = this.filter as any;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
      reportFilter.serviceDateTo = this.referenceMonthFilterComponent.optionSelected;
      reportFilter.serviceDateFrom = this.referenceMonthFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
      reportFilter.serviceDateTo = reportFilter.serviceDate;
      reportFilter.serviceDateFrom = reportFilter.serviceDate;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }
    // this.offset.actualQuantityFilter = this.actualQuantityFilter;

    this.loaderService.display(true);
    this.generateConsuntivoVolumiXlsx(reportFilter, isGrouped);
  }

  shareXlsx(isGrouped: boolean = false) {
    this.getAllFilters();
    const reportFilter = this.filter as any;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
      reportFilter.serviceDateTo = this.referenceMonthFilterComponent.optionSelected;
      reportFilter.serviceDateFrom = this.referenceMonthFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
      reportFilter.serviceDateTo = reportFilter.serviceDate;
      reportFilter.serviceDateFrom = reportFilter.serviceDate;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('Year month filter is missing.');
    }
    // this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const dialogRef = this.dialog.open(DialogSendEmailComponent, {
      data: {
        currentBaseUrl: this.billingService.baseUrl,
        isComparing: this.isComparing,
        isGrouped: isGrouped,
        offset: this.offset,
        filter: reportFilter
      }
    });
  }

  generateConsuntivoVolumiXlsx(reportFilter, isGrouped: boolean) {
    let fileName = 'Billing';
    if (this.isError) {
      fileName = 'Billing Errors';
    }
    this.getNameSubscribe = this.billingService.getNameGenerateXlsx(this.offset, reportFilter, this.isComparing, isGrouped)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    // this.offset.actualQuantityFilter = this.actualQuantityFilter;

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUNTIVO_VOLUMI},
        {id: 'quotationRequest', value: undefined},
        {id: 'comparing', value: this.isComparing}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
      this.filter.serviceDate = this.referenceMonthFilterComponent.optionSelected;
    }
    if (this.filter.provider.cod !== this.PROVIDER_IBM || !this.filter.provider.cod.includes(this.PROVIDER_KYN)) {
      this.filter.contractType = this.contractType ? this.contractType : undefined;
    }
    if (this.filter.provider.cod.includes(this.PROVIDER_KYN)) {
      this.filter.designServices = 
      this.filter.country = this.country ? this.country : undefined;
      this.filter.designServices = this.tower ? this.tower : undefined;
    }
    if (this.filter.provider.cod !== this.PROVIDER_DXC) {
      this.filter.localCustomer = this.localCustomer ? this.localCustomer : undefined;
    }
    if(this.claimsFilterComponent.claims == 0 || this.claimsFilterComponent.claims == 1)
      this.filter.claim = this.claimsFilterComponent.claims == '1' ? 1 : 0;
    else
      this.filter.claim = undefined;
    this.filter.orderCode = this.orderCode ? this.orderCode : undefined;
    this.filter.chargingStructure = this.chargingStructure ? this.chargingStructure : undefined;
    this.filter.serviceType = this.serviceType ? this.serviceType : undefined;
    this.filter.invoiceCode = this.invoiceCode ? this.invoiceCode : undefined;
    this.filter.invoiceDescription = this.invoiceDescription ? this.invoiceDescription : undefined;

    this.loaderService.display(false);
  }

  isLocalCustomerFilterActive(): boolean {
    if (this.filter && this.filter.provider && this.filter.provider.cod) {
      return this.filter.provider.cod !== 'DXC';
    }
    console.error('no provider found');
    return false;
  }

  ngOnDestroy(): void {

  }

}
